if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form") || this;
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        console.log("on submit");

        evt.preventDefault();

        console.log("startCheck 1");
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        console.log("startCheck 2");
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        console.log("startCheck 3");
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Add line item property for Finish

        let finishSwatchValue = null;
        const swatches = document.querySelectorAll(".swatch_input");
        console.log("swatches length: " + swatches.length);
        swatches.forEach((input) => {
          console.log("is checked:" + input.checked);
          if (input.checked) {
            finishSwatchValue = input.value;
          }
        });

        const woodFinishValue = document.querySelector(
          'input[name="properties[Wood Finish]"]:checked'
        )?.value;

        const metalFinishValue = document.querySelector(
          'input[name="properties[Metal Finish]"]:checked'
        )?.value;

        const fabricFinishValue = document.querySelector(
          'input[name="properties[Fabric Finish]"]:checked'
        )?.value;

        const customSizeWidth = document.querySelector('input[name="properties[Width]"]');
        const customSizeDepth = document.querySelector('input[name="properties[Depth]"]');
        const customSizeHeight = document.querySelector('input[name="properties[Height]"]');

 
// get the dropdown value
const customSizeOption = document.querySelector('select[name="options[Custom Size]"]');
const customSizeOptionValue = customSizeOption ? customSizeOption.value.toLowerCase() : "";

if (customSizeOptionValue === "yes") {

  formData.append("properties[Width]", customSizeWidth.value);
  formData.append("properties[Depth]", customSizeDepth.value);

  if (customSizeHeight.value) {
    formData.append("properties[Height]", customSizeHeight.value);
  }

  console.log("✅ Custom Size added:", customSizeWidth.value);
} else {
  console.warn("⚠️ No size selected");
}



        if (woodFinishValue) {
          formData.append("properties[Wood Finish]", woodFinishValue);
          console.log("✅ Wood Finish added:", woodFinishValue);
        } else {
          console.warn("⚠️ No wood finish selected");
        }

        if (metalFinishValue) {
          formData.append("properties[Metal Finish]", metalFinishValue);
          console.log("✅ Metal Finish added:", metalFinishValue);
        } else {
          console.warn("⚠️ No metal finish selected");
        }

        if (fabricFinishValue) {
          formData.append("properties[Fabric Finish]", fabricFinishValue);
          console.log("✅ Fabric Finish added:", fabricFinishValue);
        } else {
          console.warn("⚠️ No Fabric finish selected");
        }


        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
